
<!--
  ref="editablePage" est utilisé pour accéder aux propriétés de la page de n'importe quel component 
  Solution:
  this.$root.$children[0].$children.find(el => el.$refs && el.$refs.editablePage != undefined).$refs.editablePage.content
-->
<EditablePage
  v-if="content"
  ref="editablePage"
  :content="content"
  :config="config"
  :templateDefinitions="templateDefinitions"
/>
